import { Link } from "react-router-dom";
import styles from "./Product.module.css";

const ProductListItem = ({ item }) => {
  return (
    <div className={styles.productItemWrapper}>
      <div className={styles.productTitleWrapper}>
        <div className={styles.productTitle}>{item.title}</div>
      </div>
      <div className={styles.datesForProduct}>
        <i className={"fa fa-calendar"}></i> تاریخ انتشار : {item.created}
      </div>
      <div
        className={styles.productSummary}
        dangerouslySetInnerHTML={{
          __html: item.summary ? item.summary : "بدون توضیحات",
        }}
      ></div>
      <div className={styles.productListItemReadMore}>
        <Link
          to={`/product/show/${item.id}`}
          className={styles.productListItemReadMoreLink}
        >
          بیشتر <i className="fa fa-arrow-left" />
        </Link>
      </div>
    </div>
  );
};

export default ProductListItem;
